import { IsIn, IsNotEmpty, IsOptional } from "class-validator";

import { Constants } from "@river/constants";

import { IAdapterBaseline } from "./adapter-baseline.interface";

export class AdapterBaselineDto implements Omit<IAdapterBaseline, "_id"> {
  @IsNotEmpty()
  folder_id: string;

  @IsNotEmpty()
  baseline: string;

  @IsOptional()
  description?: string;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.baseline_mode))
  baseline_mode: string = Constants.baseline_mode.manual;
  //commit_type?: string;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.baseline_type))
  baseline_type: string = Constants.baseline_type.snapshot;

  @IsOptional()
  display_options?: string;

  [s: string]: any;
}
